import { render } from "./LineChart.vue?vue&type=template&id=4356379a"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"
script.render = render

export default script